export default {"src":"/_next/static/media/payx.732ff401.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};